import { UseFormReturn } from 'react-hook-form';
import { observer } from 'mobx-react-lite';
import { EventPanelFormType } from '@mark43/cad-api';
import { LoadingIndicator } from '../common/components/loading-indicator';
import { useUnitDispositionContent } from '../fr-event-common-components/fr-disposition/hooks/use-unit-disposition-content';
import { FrClearEventContainer } from './components/fr-clear-event-container';
import { FrDispositionPageContent } from './components/fr-disposition-page-content';
import { useIntegratedForm } from '../forms/use-integrated-form';

export const FrClearEventPage = observer(function FrClearEventPage() {
    const {
        eventId,
        unitId,
        isPrimaryUnitForAssignedEvent,
        dispositionOptions,
        agencyId,
        agencyTypeGlobalAttrId,
        cautions,
        areCautionsLoading,
        eventLocation,
        eventForm,
    } = useUnitDispositionContent();
    const { query: eventQuery } = useIntegratedForm();

    if (eventQuery.isFetching) {
        return <LoadingIndicator />;
    }

    return (
        <FrClearEventContainer eventId={eventId}>
            <FrDispositionPageContent
                isClearEventPage
                primaryDispositionEditable={!!isPrimaryUnitForAssignedEvent}
                saveMutationErrorMsg="clearing event"
                eventId={eventId}
                unitId={unitId}
                isPrimaryUnit={!!isPrimaryUnitForAssignedEvent}
                dispositionOptions={dispositionOptions}
                agencyId={agencyId}
                agencyTypeGlobalAttrId={agencyTypeGlobalAttrId}
                cautions={cautions}
                areCautionsLoading={areCautionsLoading}
                eventLocation={eventLocation}
                eventForm={(eventForm as unknown) as UseFormReturn<EventPanelFormType>}
            />
        </FrClearEventContainer>
    );
});
